import { inject } from '@angular/core';
import { signalStore, type, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import {
  withCallStatus,
  withEntitiesLoadingCall,
  withLogger,
} from '@ngrx-traits/signals';
import { TenantOption, TenantOptionService } from '..';

const tenantOptionConfig = entityConfig({
  entity: type<TenantOption>(),
  collection: 'tenantOption',
});

export const TenantOptionStore = signalStore(
  withEntities(tenantOptionConfig),
  withCallStatus(tenantOptionConfig, {
    initialValue: 'init',
  }),
  withLogger({ name: 'TenantOptionStore' }),
  withProps(() => ({
    _tenantOptionService: inject(TenantOptionService),
  })),
  withEntitiesLoadingCall(tenantOptionConfig, {
    fetchEntities: ({ _tenantOptionService }) =>
      _tenantOptionService.loadList(),
  })
);
